import Deals from "./Deals"
import Details from "./Details"

export {
  Deals,
  Details,
}
